import React, { useState, useEffect } from 'react';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import HowItWorksSection from './components/HowItWorksSection';
import SocialProofSection from './components/SocialProofSection';
import Footer from './components/Footer';
import IntegrationAssessmentModal from './components/IntegrationAssessmentModal';
import './App.css';

function App() {
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    // Show modal after a short delay to ensure page is loaded
    const timer = setTimeout(() => {
      setShowModal(true);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  const handleCloseModal = () => {
    setShowModal(false);
  };

  return (
    <div className="App">
      <Header />
      <HeroSection />
      <FeaturesSection />
      <HowItWorksSection />
      <SocialProofSection />
      <Footer />
      <IntegrationAssessmentModal 
        isOpen={showModal} 
        onClose={handleCloseModal} 
      />
    </div>
  );
}

export default App;
